import { HugeiconsIcon } from "@hugeicons/react";
import { Loading03Icon } from "@hugeicons-pro/core-duotone-rounded";
import type { ComponentProps } from "react";
import { cn } from "~/lib/utils";

export function LoadingIndicator({
	className,
	...props
}: Omit<ComponentProps<typeof HugeiconsIcon>, "icon">) {
	return (
		<HugeiconsIcon
			icon={Loading03Icon}
			className={cn("animate-spin", className)}
			{...props}
		/>
	);
}
